import React from 'react';
import { RefreshCw } from 'lucide-react';
import Button from 'components/Button';
import styles from './RefreshButton.module.scss';

interface RefreshButtonProps {
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  title?: string;
}

function RefreshButton({
  onClick,
  loading = false,
  disabled = false,
  title = 'Refresh',
}: RefreshButtonProps) {
  return (
    <Button
      onClick={onClick}
      variant="outline"
      disabled={disabled || loading}
      className={styles.refreshButton}
      title={title}
    >
      <RefreshCw size={18} className={loading ? styles.spinning : ''} />
      <span className={styles.refreshButtonText}>Refresh</span>
    </Button>
  );
}

export default RefreshButton;
